export function resolvePublicOrigin(configuredUrl: string | undefined, browserOrigin: string): string {
  const origin = configuredUrl?.trim() || browserOrigin;
  return origin.replace(/\/+$/, '');
}

export function createPhonePairingUrl(
  roomId: string,
  configuredUrl: string | undefined,
  browserOrigin: string
): string {
  const url = new URL('/phone-pairing', `${resolvePublicOrigin(configuredUrl, browserOrigin)}/`);
  url.searchParams.set('room', roomId);
  return url.toString();
}
